export const notify = ({message, type}) => {
  console.log("[LOG]", type, message)
}